export const GET_TIMELINE_BLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    timelineBlock(id: "${id}", preview: ${preview}) {
      sys {
        id
      }
      heading
      text
      stepsCollection {
        items {
          __typename
          ... on RestrictedRichTextBlock {
            sys {
              id
            }
          }
        }
      }
      audienceCollection{
        items{
            __typename
            sys{id}
            audianceId
          }
      }
    }
  }
`;
